var map = {
	"./template.betprofessor": 1510,
	"./template.betprofessor.tsx": 1510,
	"./template.betroyale": 1511,
	"./template.betroyale.tsx": 1511,
	"./template.default": 665,
	"./template.default.tsx": 665,
	"./template.fiestabet": 1512,
	"./template.fiestabet.tsx": 1512,
	"./template.goldenbet888": 1513,
	"./template.goldenbet888.tsx": 1513,
	"./template.goldrenrush": 1514,
	"./template.goldrenrush.tsx": 1514,
	"./template.puntcity": 1515,
	"./template.puntcity.tsx": 1515,
	"./template.puntgenie": 1516,
	"./template.puntgenie.tsx": 1516,
	"./template.questbet": 1517,
	"./template.questbet.tsx": 1517,
	"./template.sterlingparker": 1518,
	"./template.sterlingparker.tsx": 1518,
	"./template.ts": 978,
	"./template.vikingbet": 1519,
	"./template.vikingbet.tsx": 1519,
	"./template.volcanobet": 1520,
	"./template.volcanobet.tsx": 1520,
	"./template.wellbet": 1521,
	"./template.wellbet.tsx": 1521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2442;